import { AnyAction } from "redux";

import { LoginType, LogoutType, LoggedInUser } from '../actions/actionTypes';
import { updateObject } from '../../services/utilService';
import { IUser } from "../../shared/models/adminModels";

interface IAuthReducerState {
    isLoggedIn: boolean | null;
    user: IUser;
}

const initialState  = {
    isLoggedIn: null,
    user: {}
};

const login = (state: any, action: any) => {
    return updateObject(state, { isLoggedIn: true });
}

const logout = (state: any, action: any) => {
    return updateObject(state, { isLoggedIn: false });
}

const loggedInUser = (state: any, action: any) => {
    return updateObject(state, { user: action.payload });
}

const authReducer = (state = initialState, action: AnyAction) => {
    switch(action.type) {
        case LoginType: return login(state, action);
        case LogoutType: return logout(state, action);
        case LoggedInUser: return loggedInUser(state, action);
        default: return state;
    } 
}

export default authReducer;